import React from 'react';
import { IconProps, IconWrap } from './IconWrap';
import styled from 'styled-components';

export const IconEyeAlt = styled(({ color = '#58B1FC', width = 14, height = 11, ...props }: IconProps) => {
    return (
        <IconWrap {...props} viewBox="0 0 14 11" width={width} height={height} iconClass="eye-alt">
            <path
                d="M8.474 5.84229C8.474 6.45594 7.97654 6.9534 7.36289 6.9534C6.74924 6.9534 6.25178 6.45594 6.25178 5.84229C6.25178 5.22864 6.74924 4.73117 7.36289 4.73117C7.97654 4.73117 8.474 5.22864 8.474 5.84229Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.36289 0.842285C4.25649 0.842285 1.64632 2.96691 0.90625 5.84229C1.64632 8.71767 4.25649 10.8423 7.36289 10.8423C10.4693 10.8423 13.0795 8.71767 13.8195 5.84229C13.0795 2.96691 10.4693 0.842285 7.36289 0.842285ZM9.58511 5.84229C9.58511 7.06958 8.59019 8.06451 7.36289 8.06451C6.13559 8.06451 5.14067 7.06958 5.14067 5.84229C5.14067 4.61499 6.13559 3.62006 7.36289 3.62006C8.59019 3.62006 9.58511 4.61499 9.58511 5.84229Z"
                fill={color}
            />
        </IconWrap>
    );
})``;
